import React, { FC, useEffect } from 'react';
import { RouteProps, Switch } from 'react-router-dom';
import { Route, useHistory } from 'react-router';
import { ClientRoute } from '../../../config/clientRoutes/types';
import { useLocation } from 'react-use';
import { LogActionTypes, useDataLogging } from '../../shared/data-logging';
import { useI18nPath } from '../../../config/clientRoutes/hooks';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import { setSolutionsMode } from 'src/modules/shared/slices/solutions/entity/solutionsModeSlice';

type Props = {
  routes: ClientRoute[];
  fallBackPage: RouteProps['component'];
};

function onConversationsAPIReady() {
  console.log(`HubSpot Conversations API: ${window.HubSpotConversations}`);
}

const env = process.env.REACT_APP_ENVIRONMENT;

export const PageWrapper: FC = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const { getRouteNameFromPath } = useI18nPath();
  const dispatch = useAppDispatch();
  const log = useDataLogging();

  useEffect(() => {
    if (getRouteNameFromPath(location.pathname || '') !== 'trajectoryView') {
      dispatch(setSolutionsMode(false));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    if (env === 'demo') {
      window?.HubSpotConversations?.widget.refresh();
      window.hsConversationsOnReady = [onConversationsAPIReady];
      window?.HubSpotConversations?.widget.load();
    }
  }, []);

  useEffect(() => {
    if (history.action !== 'POP') {
      // in case action is not POP it will be push or replace
      log(LogActionTypes.USER_NAVIGATES_THROUGH_CLICK);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, log]);

  return <>{children}</>;
};

const Routes: FC<Props> = ({ routes, fallBackPage }) => {
  return (
    <>
      <Switch>
        {routes.map((route) => {
          const Component = route.component as React.FunctionComponent;
          return (
            <Route
              path={route.path}
              exact={route.exact}
              render={() => (
                <PageWrapper>
                  <Component />
                </PageWrapper>
              )}
              key={route.routeId}
            />
          );
        })}
        <Route component={fallBackPage} />
      </Switch>
    </>
  );
};

export default Routes;
